(function () {
  class OrbDisplay extends PIXI.Container {
    constructor() {
      super();

      messageBus.subscribe('spinner:GameConfigEvent', this.onGameConfigEvent.bind(this));
      messageBus.subscribe('spinner:ShuffleIntroEvent', this.onShuffleIntroEvent.bind(this));
      messageBus.subscribe('spinner:XtraPowerIntroEvent', this.onXtraPowerIntroEvent.bind(this));
      messageBus.subscribe('sidewinder:PowerBarAdjustEvent', this.onPowerBarAdjust.bind(this));
      messageBus.subscribe('spinner:ShuffleEndEvent', this.onShuffleEndEvent.bind(this));
      messageBus.subscribe('sidewinder:xtraPowerRedBackground', this.onXtraPowerRedBackground.bind(this));
      messageBus.subscribe('sidewinder:XtraPowerTriggerEvent', this.onXtraPowerTriggerEvent.bind(this));
      Reflex.registerEventHandler('layoutChange', this.onLayoutChange.bind(this));
      Reflex.addToUpdate(this.update.bind(this));
    }

    initialise() {
      this._jsonPath = this.name;
      this._orbCount = 5;
      this._orbPanels = [];
      this._orbsMoved = 0;

      this._multiplierTrail = undefined;
      this._logoPopupDisplay = undefined;
      this._xtraPowerSideText = undefined;
      this._powerBarDisplay = undefined;
      this._backgroundLightningDisplay = undefined;
      this._XtraPowerIntroTask = undefined;
      this._powerBarAdjustTask = undefined;

      this._orbMoveTween = undefined;
      this._orbCometTrailTween = undefined;
      this._shouldHardResetOrbs = true;
      this._allOrbsLit = false;
      this._currentOrbMoved = -1;
      this._xtraPowerActive = false;
    }

    update(delta, time) {}

    onGameConfigEvent() {
      const cometTrailAnimContainer = resourceManager.get(this._jsonPath + ':cometTrailAnimContainer');
      this._cometTrailAnim = particleManager.createEmitter('orbCometTrail', cometTrailAnimContainer.name, 0, 0, false);
      this._cometTrailAnim.particleEmitter.emit = false;
      this._cometTrailAnim.visible = false;

      for (let i = 0; i < this._orbCount; i++) {
        let orbPanel = {
          parent: resourceManager.get(this._jsonPath + ':Orb_' + i),
          blueOff: resourceManager.get(this._jsonPath + ':Orb_' + i + ':blue:blueOff'),
          redOff: resourceManager.get(this._jsonPath + ':Orb_' + i + ':red:redOff'),
          blueSparks: resourceManager.get(this._jsonPath + ':Orb_' + i + ':blue:blueOrbSparks'),
          redSparks: resourceManager.get(this._jsonPath + ':Orb_' + i + ':red:redOrbSparks'),
          blueParent: resourceManager.get(this._jsonPath + ':Orb_' + i + ':blue'),
          redParent: resourceManager.get(this._jsonPath + ':Orb_' + i + ':red'),
          orbZap: resourceManager.get(this._jsonPath + ':Orb_' + i + ':orbSphereZap'),
          xtraPower: resourceManager.get(this._jsonPath + ':Orb_' + i + ':xtraPowerValues'),
          lit: false,
          xpValue: 0,
        };

        orbPanel.blueOff.visible = false;
        orbPanel.redOff.visible = false;
        orbPanel.blueSparks.gotoAndStop(0);
        orbPanel.blueSparks.visible = false;
        orbPanel.blueSparks.blendMode = PIXI.BLEND_MODES.ADD;
        orbPanel.redSparks.gotoAndStop(0);
        orbPanel.redSparks.visible = false;
        orbPanel.redSparks.blendMode = PIXI.BLEND_MODES.ADD;
        orbPanel.orbZap.gotoAndStop(0);
        orbPanel.orbZap.visible = false;
        orbPanel.orbZap.blendMode = PIXI.BLEND_MODES.ADD;
        orbPanel.xtraPower.gotoAndStop(0);
        orbPanel.xtraPower.visible = false;
        orbPanel.blueParent.visible = false;
        orbPanel.redParent.visible = false;

        this._orbPanels.push(orbPanel);
      }
      this.resetOrbPositions();

      this._multiplierTrail = resourceManager.get('multiplierTrailWrapper:multiplierTrail:multiplierTrail');
      this._logoPopupDisplay = resourceManager.get('logoPopupDisplay:logoPopupDisplay');
      this._xtraPowerSideText = resourceManager.get('xtraPowerSideText:xtraPowerSideText');
      this._powerBarDisplay = resourceManager.get('powerBarDisplay:powerBarDisplay');
      this._backgroundLightningDisplay = resourceManager.get(
        'slotContainer:backgroundLightningDisplay:backgroundLightningDisplay'
      );
    }

    onShuffleIntroEvent(task) {
      soundManager.play('orbPulse');
      for (let i = 0; i < this._orbPanels.length; i++) {
        let parent = this._orbPanels[i].parent;

        gsap.to(parent.scale, {
          x: 1.5,
          y: 1.5,
          duration: 0.2,
          yoyo: true,
          repeat: 5,
          ease: 'linear',
          onComplete: () => {},
        });
      }
    }

    onPowerBarAdjust(task) {
      this._powerBarAdjustTask = task;
      this._powerBarAdjustTask.join();

      const orbs = task.data.powerSpheres;
      const powerAdded = orbs.totalPowerAdded;

      let activeOrbs = [];
      for (let i = 0; i < orbs.spheres.length; i++) {
        if (orbs.spheres[i].lit) {
          activeOrbs.push(i);
        }
      }

      const self = this;
      timerManager.addTimeout(500, function () {
        self.pulsePowerOrbs(activeOrbs, powerAdded);
      });
    }

    onXtraPowerTriggerEvent(task) {
      this.onXtraPowerRedBackground({ enabled: true });
    }

    onXtraPowerRedBackground(data) {
      const ORB_TRANSITION_DURATION = 0.25;
      const oldOrbTimeline = gsap.timeline();
      const newOrbTimeline = gsap.timeline();
      const scaleOrbTimeline = gsap.timeline();

      if (data.enabled && data.time) {
        soundManager.play('orbLightUp');
      }

      let skipOrbSwitch = false;

      for (let i = 0; i < this._orbCount; i++) {
        let oldOrb, newOrb;
        if (data.enabled) {
          oldOrb = this._orbPanels[i].blueParent;
          newOrb = this._orbPanels[i].redParent;
          newOrb.alpha = 0;
          newOrb.visible = true;

          if (this._orbPanels[i].redParent.visible) {
            skipOrbSwitch = true;
            newOrb.alpha = 1;
          }
        } else {
          oldOrb = this._orbPanels[i].redParent;
          newOrb = this._orbPanels[i].blueParent;
          newOrb.alpha = 0;
          newOrb.visible = true;

          if (this._orbPanels[i].blueParent.visible) {
            skipOrbSwitch = true;
            newOrb.alpha = 1;
          }
        }

        if (!this._allOrbsLit) {
          this.stopOrbSparks(i);
        }

        if (!skipOrbSwitch) {
          oldOrbTimeline.to(oldOrb, {
            alpha: 0,
            duration: ORB_TRANSITION_DURATION,
            ease: 'linear',
            onStart: () => {},
            onComplete: () => {
              oldOrb.visible = false;
              oldOrb.alpha = 1;
            },
          });
          if (!data.time) {
            oldOrbTimeline.progress(1);
          }
          newOrbTimeline.to(newOrb, {
            alpha: 1,
            duration: ORB_TRANSITION_DURATION,
            ease: 'linear',
            onComplete: () => {
              newOrb.alpha = 1;
            },
          });
          if (!data.time) {
            newOrbTimeline.progress(1);
          }
          scaleOrbTimeline.to([oldOrb, newOrb], {
            pixi: { scale: 1.4 },
            duration: ORB_TRANSITION_DURATION / 2,
            ease: 'linear',
            yoyo: true,
            repeat: 1,
          });
          if (!data.time) {
            scaleOrbTimeline.progress(1);
          }
        }
      }
    }

    pulsePowerOrbs(activeOrbs, powerAdded) {
      soundManager.play('orbPulse');

      for (let i = 0; i < activeOrbs.length; i++) {
        let activeOrbIndex = activeOrbs[i];
        let parent = this._orbPanels[activeOrbIndex].parent;

        gsap.to(parent.scale, {
          x: 1.5,
          y: 1.5,
          duration: 0.2,
          yoyo: true,
          repeat: 5,
          ease: 'linear',
          onComplete: () => {},
        });
      }

      const self = this;
      timerManager.addTimeout(1500, function () {
        self.zapPowerBar(activeOrbs, powerAdded);
      });
    }

    zapPowerBar(activeOrbs, powerAdded) {
      if (this._powerBarDisplay.isFull(powerAdded)) {
        soundManager.play('powerBarZapFull');
      } else {
        soundManager.play('powerBarZap');
      }

      const zapTime = 1.0;
      const addedAmount = powerAdded / activeOrbs.length;

      for (let i = 0; i < activeOrbs.length; i++) {
        let activeOrbIndex = activeOrbs[i];

        gsap.to(this._orbPanels[activeOrbIndex].parent, {
          pixi: { scale: 1.0 },
          duration: zapTime / 2,
          ease: 'linear',
          yoyo: true,
          repeat: 1,
        });

        gsap.to(this, {
          duration: zapTime,
          onStart: () => {
            this._orbPanels[activeOrbIndex].orbZap.gotoAndPlay(0);
            this._orbPanels[activeOrbIndex].orbZap.visible = true;
            this._orbPanels[activeOrbIndex].blueOff.visible = true;
            this._powerBarDisplay.incrementPowerBar(addedAmount, zapTime);
          },
          onComplete: () => {
            // this._orbPanels[activeOrbIndex].blueSparks.visible = false;
            // this._orbPanels[activeOrbIndex].blueSparks.alpha = 1;
            this._orbPanels[activeOrbIndex].orbZap.gotoAndStop(0);
            this._orbPanels[activeOrbIndex].orbZap.visible = false;
            this._orbPanels[activeOrbIndex].blueOff.visible = false;
            if (i === activeOrbs.length - 1) {
              this.orbZapsComplete();
            }
          },
        });
      }
    }

    orbZapsComplete() {
      const barLevel = this._powerBarAdjustTask.data.xPowerBar.finalBarPower;
      this._backgroundLightningDisplay.checkForLevelChange(barLevel);
      this._powerBarAdjustTask.leave();
      this._powerBarAdjustTask = undefined;
    }

    onXtraPowerIntroEvent(task) {
      this._xtraPowerActive = true;

      this._XtraPowerIntroTask = task;
      this._XtraPowerIntroTask.join();
      this._shouldHardResetOrbs = false;

      this._orbsMoved = 0;
      const sphereBoosts = task.data.sphereBoosts;

      const self = this;
      for (let i = 0; i < this._orbCount; i++) {
        this._orbPanels[i].xpValue = sphereBoosts[i];
        if (sphereBoosts[i] > 0) {
          this._orbPanels[i].xtraPower.gotoAndStop(sphereBoosts[i] - 1);
        }

        const isFinal = i === this._orbCount - 1;

        gsap.to(this._orbPanels[i].parent, {
          pixi: { scale: 1.4 },
          delay: 1 + i * 0.25,
          duration: 0.25 / 2,
          ease: 'linear',
          yoyo: true,
          repeat: 1,
          onStart: () => {
            if (i === 0) {
              soundManager.play('xtraPowerPopup');
            }
            this._orbPanels[i].redSparks.gotoAndPlay(0);
            this._orbPanels[i].redSparks.visible = true;
            this._orbPanels[i].redOff.visible = true;
          },
          onComplete: () => {
            if (isFinal) {
              this._logoPopupDisplay.startLogoPulse();
              this._xtraPowerSideText.startActivePulse();
              timerManager.addTimeout(500, function () {
                self.revealXtraPowerValues();
              });
            }
          },
        });
      }
    }

    revealXtraPowerValues() {
      const self = this;

      const DELAY = 0.5;

      for (let i = 0; i < this._orbCount; i++) {
        this._orbPanels[i].blueSparks.visible = false;
        this._orbPanels[i].blueSparks.alpha = 1;
        this._orbPanels[i].blueSparks.gotoAndStop(0);

        const orb = this._orbPanels[i].parent;
        const xtraPowerValue = this._orbPanels[i].xtraPower;

        xtraPowerValue.scale.set(0);
        xtraPowerValue.visible = true;

        gsap.to(orb, {
          pixi: { scale: 1.6 },
          delay: i * DELAY,
          duration: 0.25,
          ease: 'power1.inOut',
          onComplete: () => {
            if (i === this._orbCount - 1) {
              self.moveNextOrb();
            }
          },
        });
        gsap
          .timeline()
          .to(xtraPowerValue, {
            pixi: { scale: 1.4 },
            delay: i * DELAY,
            duration: 0.25,
            ease: 'power1.inOut',
          })
          .to(xtraPowerValue, {
            pixi: { scale: 1 },
            duration: 0.1,
            ease: 'power1.inOut',
          });
        gsap.to(this._orbPanels[i].redSparks, {
          alpha: 1,
          delay: i * DELAY,
          duration: 0.25 / 2,
          ease: 'linear',
          onComplete: () => {
            //this._orbPanels[i].redSparks.visible = false;
            //this._orbPanels[i].redSparks.alpha = 1;
            //this._orbPanels[i].redSparks.gotoAndStop(0);
            this._orbPanels[i].redOff.visible = false;
          },
        });
      }
    }

    moveNextOrb() {
      if (this._orbsMoved >= this._orbCount) {
        this._multiplierTrail.resetFlashAnim();
        this._cometTrailAnim.particleEmitter.emit = false;
        this._cometTrailAnim.visible = false;
        this.allOrbsMoved();
      } else {
        this._currentOrbMoved++;
        const self = this;
        let endPos = this._multiplierTrail.getCurrentTrailScreenPosition();
        // Jamie - sort this later
        if (layoutController.getCurrentLayout() != 'portrait_default') {
          endPos.x -= 45;
        } else {
          endPos.x += 220;
          endPos.y -= 116;
        }

        const panel = this._orbPanels[this._orbsMoved].parent;
        const levelAmount = this._orbPanels[this._orbsMoved].xpValue;

        this._cometTrailAnim.particleEmitter.spawnPos.x = panel.position.x;
        this._cometTrailAnim.particleEmitter.spawnPos.y = panel.position.y;

        this._orbCometTrailTween = gsap.to(this._cometTrailAnim.particleEmitter.spawnPos, {
          x: endPos.x,
          y: endPos.y,
          duration: 0.7,
          ease: 'power1.inOut',
          onStart: () => {
            this._cometTrailAnim.visible = true;
            this._cometTrailAnim.particleEmitter.emit = true;
          },
        });
        this._orbMoveTween = gsap.to(panel, {
          pixi: { scale: 0.8 },
          x: endPos.x,
          y: endPos.y,
          duration: 0.7,
          ease: 'power1.inOut',
          onStart: () => {
            this._multiplierTrail.readyFlashAnim();
          },
          onComplete: () => {
            soundManager.play('multiplierTrailLevelIncrease');
            panel.position.set(endPos.x, endPos.y);
            this._orbsMoved++;
            this._multiplierTrail.shiftPanelsDown(true, levelAmount, self.moveNextOrb.bind(self));
            panel.scale.set(0);
            this._multiplierTrail.playFlashAnim();
          },
        });
      }
    }

    allOrbsMoved() {
      for (let i = 0; i < this._orbPanels.length; i++) {
        this._orbPanels[i].redSparks.visible = false;
        this._orbPanels[i].redSparks.alpha = 1;
        this._orbPanels[i].redSparks.gotoAndStop(0);
      }

      this._logoPopupDisplay.stopLogoPulse();
      this._xtraPowerSideText.stopActivePulse();
      this._XtraPowerIntroTask.leave();
      this._XtraPowerIntroTask = undefined;
    }

    onLayoutChange() {
      if (this._orbPanels && this._orbPanels.length > 0) {
        this.resetOrbPositions();
      }

      if (this._orbMoveTween != null) {
        this._orbMoveTween.progress(1);
      }
      if (this._orbCometTrailTween != null) {
        this._orbCometTrailTween.progress(1);
      }
    }

    setOrbStatus(orbData) {
      this._allOrbsLit = true;

      for (let i = 0; i < this._orbCount; i++) {
        this._orbPanels[i].lit = orbData[i].lit;

        if (!this._orbPanels[i].lit) {
          this._allOrbsLit = false;
        }
      }
    }

    reelLanded(reel) {
      if (this._orbPanels[reel].lit && !this._xtraPowerActive) {
        this._orbPanels[reel].blueSparks.gotoAndPlay(0);
        this._orbPanels[reel].blueSparks.visible = true;
        //this._orbPanels[reel].blueOff.visible = true;

        gsap.to(this._orbPanels[reel].blueSparks.scale, {
          x: 1.2,
          y: 1.2,
          duration: 0.25,
          ease: 'power1.inOut',
          onComplete: () => {
            this._orbPanels[reel].blueSparks.scale.set(1.2);

            gsap.to(this._orbPanels[reel].blueSparks.scale, {
              x: 1.0,
              y: 1.0,
              duration: 0.25,
              ease: 'power1.inOut',
              onComplete: () => {
                this._orbPanels[reel].blueSparks.scale.set(1);
              },
            });
          },
        });

        this._orbPanels[reel].redSparks.gotoAndPlay(0);
        this._orbPanels[reel].redSparks.visible = true;
        //this._orbPanels[reel].redOff.visible = true;

        gsap.to(this._orbPanels[reel].redSparks.scale, {
          x: 1.2,
          y: 1.2,
          duration: 0.25,
          ease: 'power1.inOut',
          onComplete: () => {
            this._orbPanels[reel].redSparks.scale.set(1.2);

            gsap.to(this._orbPanels[reel].redSparks.scale, {
              x: 1.0,
              y: 1.0,
              duration: 0.25,
              ease: 'power1.inOut',
              onComplete: () => {
                this._orbPanels[reel].redSparks.scale.set(1);
              },
            });
          },
        });
      }
    }

    stopOrbSparks(i) {
      this._orbPanels[i].blueSparks.visible = false;
      this._orbPanels[i].blueSparks.gotoAndStop(0);
      this._orbPanels[i].blueSparks.alpha = 1;
      //this._orbPanels[i].blueOff.visible = true;

      this._orbPanels[i].redSparks.visible = false;
      this._orbPanels[i].redSparks.gotoAndStop(0);
      this._orbPanels[i].redSparks.alpha = 1;
      //this._orbPanels[i].redOff.visible = true;
    }

    stopAllOrbSparks() {
      for (let i = 0; i < this._orbCount; i++) {
        gsap.to(this._orbPanels[i].blueSparks, {
          alpha: 0,
          duration: 0.2,
          ease: 'linear',
          onComplete: () => {
            this._orbPanels[i].blueSparks.visible = false;
            this._orbPanels[i].blueSparks.gotoAndStop(0);
            this._orbPanels[i].blueSparks.alpha = 1;
          },
        });
        //this._orbPanels[i].blueOff.visible = true;

        gsap.to(this._orbPanels[i].redSparks, {
          alpha: 0,
          duration: 0.2,
          ease: 'linear',
          onComplete: () => {
            this._orbPanels[i].redSparks.visible = false;
            this._orbPanels[i].redSparks.gotoAndStop(0);
            this._orbPanels[i].redSparks.alpha = 1;
          },
        });
        //this._orbPanels[i].redOff.visible = true;
      }
    }

    resetOrbPositions() {
      if (this._shouldHardResetOrbs) {
        this._currentOrbMoved = -1;
      }

      for (let i = 0; i < this._orbCount; i++) {
        const orbPos = resourceManager.get(this._jsonPath + ':Orb_' + i + '_Pos');

        if (this._shouldHardResetOrbs) {
          this._orbPanels[i].parent.position.set(orbPos.x, orbPos.y);
          this._orbPanels[i].parent.scale.set(1);
          this._orbPanels[i].xtraPower.visible = false;
          this._orbPanels[i].xpValue = 0;
        } else if (i > this._currentOrbMoved) {
          this._orbPanels[i].parent.position.set(orbPos.x, orbPos.y);
        }
      }
    }

    onShuffleEndEvent() {
      this._shouldHardResetOrbs = true;
      this._xtraPowerActive = false;
      this.resetOrbPositions();
    }
  }

  let creator = function (json) {
    return new OrbDisplay();
  };

  let filesRequired = function () {
    return [];
  };

  resourceManager.registerObjectType('orbDisplay', creator, initialise, filesRequired);
})();
